import { Lock } from "lucide-react"
import { Badge } from "@/components/ui/badge"

export function OneTimeUseBadge() {
  return (
    <Badge tone="muted" className="inline-flex items-center gap-1">
      <Lock className="h-3 w-3" />
      <span>One-time use</span>
    </Badge>
  )
}
